import React from 'react';

export const GlobeIcon = () => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8178 2.55497C11.7032 3.105 11.4476 3.61573 10.0227 3.89049C6.43658 4.58202 6.54044 2.84237 7.64457 1.27661C6.68992 1.33011 5.79215 1.59938 4.99927 2.03644C4.95302 2.8347 4.40644 3.58617 3.86831 4.32604C3.74496 4.49563 3.62199 4.66469 3.50565 4.83349C3.22418 5.24189 3.44878 5.46273 3.68898 5.6989C4.01769 6.0221 4.37561 6.37403 3.50565 7.27469C3.08886 7.70619 2.48092 8.01824 1.80882 8.23108C1.90277 9.03676 2.15065 9.79562 2.52219 10.4775C4.53532 7.99921 5.636 10.9884 5.55222 13.2346C6.30316 13.5557 7.1297 13.7335 7.99733 13.7335C9.45123 13.7335 10.7904 13.2345 11.852 12.3985C11.2312 11.8958 10.5949 11.4864 9.88701 11.472C9.59338 11.4661 9.24985 11.498 8.84827 11.5783C7.59927 11.8281 7.19113 11.3457 7.16909 10.6447C7.10415 8.58027 9.08583 7.12448 10.8373 6.02978L11.6647 5.64042C12.3688 5.30909 13.1086 5.18424 13.8222 5.23601C13.4109 4.1658 12.7116 3.24162 11.8178 2.55497ZM15.3333 7.50273C15.3448 4.97932 14.0907 2.7697 12.17 1.45186C10.9857 0.639291 9.548 0.165756 7.99733 0.16675C3.95217 0.16675 0.666626 3.45492 0.666626 7.50271C0.666626 8.96821 1.0973 10.3335 1.83876 11.4789C2.63327 12.7064 3.78462 13.6815 5.14536 14.2572C5.22483 14.2909 5.30502 14.3232 5.3859 14.354C6.19733 14.6638 7.0777 14.8335 7.99733 14.8335C12.0425 14.8335 15.3333 11.5505 15.3333 7.50273Z"
        fill="#333333"
      />
    </svg>
  );
};
